import React from 'react';
import PropTypes from 'prop-types';
import SelectableButton from '../../common/SelectableButton';
import CardWithOptions from '../../../modules/Controller/Jackets/Armour';
// import FlexLayout from '../../common/FlexLayout';
// import ColorButton from '../../common/ColorButton';

const ActionPanel = ({
  onCloseButtonClick,
  children,
  currentActiveParent,
  onClearAll,
  openActionPanel,
  isCloseButtonHidden,
  // showSidePane,
  // sidePaneOption,
  label
}) => {
  // const [activeColor, setActiveColor] = useState(0);
  return (
    <div
      className="action-panel"
      style={{
        boxShadow: openActionPanel ? '0 0 10px rgba( 0, 0, 0, 0.25)' : 'unset'
      }}
    >
      {/* {showSidePane && (
        <div className="action-panel_sidepane">
          <FlexLayout>
            {sidePaneOption &&
              sidePaneOption.map((option, i) => (
                <div className="action-panel_sidepane-item">
                  <ColorButton
                    size="small"
                    isSelected={i === activeColor}
                    color={option.color}
                    text={option.text}
                    onClick={() => {
                      setActiveColor(i);
                    }}
                  />
                </div>
              ))}
          </FlexLayout>
        </div>
      )} */}
      {currentActiveParent &&
        (currentActiveParent === 'front' || currentActiveParent === 'back') && (
          <button
            onClick={onClearAll}
            type="button"
            className="action-panel_clear-btn"
          >
            Clear All {currentActiveParent}
          </button>
        )}

      {!isCloseButtonHidden && (
        <button
          onClick={onCloseButtonClick}
          type="button"
          className="action-panel_close-btn"
        >
          <div
            className="action-panel_close-icon"
            style={{
              maskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/close.svg'})`,
              WebkitMaskImage: `url(${'https://reecommdev.blob.core.windows.net/re-assets/icons/close.svg'})`
            }}
          />
        </button>
      )}

      {label && <h4 className="action-panel_head">{label}</h4>}
      <div className="action-panel_container">{children}</div>
    </div>
  );
};

ActionPanel.propTypes = {
  onCloseButtonClick: PropTypes.func,
  children: PropTypes.node,
  sidePaneOption: PropTypes.node,
  label: PropTypes.string,
  showSidePane: PropTypes.bool,
  isCloseButtonHidden: PropTypes.bool
};

ActionPanel.defaultProps = {
  onCloseButtonClick: () => {}
};

export default ActionPanel;
